/**
 * Brazilian Portuguese (pt-BR) mappings for Baseball Mobile Dashboard
 * Mobile-specific translations for baseball components
 */

export const baseballMobilePtBR = {
  // Header
  "Baseball": "Beisebol",
  "MLB games & stats": "Jogos e estatísticas da MLB",
  
  // Beta Notice
  "Live scores & predictions • Full stats coming soon": "Placares ao vivo e previsões • Estatísticas completas em breve",
  "All AI picks saved to chat history": "Todas as apostas da IA salvas no histórico do chat",
  "Go to chat to dive deeper": "Vá para o chat para se aprofundar",
  "v3-Beta: Not all features available yet": "v3-Beta: Nem todos os recursos disponíveis ainda",
  
  // Tabs
  "Games": "Jogos",
  "Standings": "Classificação",
  "Players": "Jogadores",
  
  // Status
  "LIVE": "AO VIVO",
  "Final": "Final",
  "TBD": "A definir",
  "In Progress": "Em Andamento",
  
  // Innings
  "Inning": "Entrada",
  "Top": "Parte Alta",
  "Bottom": "Parte Baixa",
  
  // Empty States
  "No games found": "Nenhum jogo encontrado",
  "Try selecting a different date": "Tente selecionar uma data diferente",
  "Select a league": "Selecione uma liga",
  "Choose a league from filters to view standings": "Escolha uma liga nos filtros para ver a classificação",
  "Player stats coming soon": "Estatísticas de jogadores em breve",
  "MLB player statistics will be available in a future update": "Estatísticas de jogadores da MLB estarão disponíveis em uma atualização futura",
  "Failed to load games": "Falha ao carregar jogos",
  "Try Again": "Tentar Novamente",
  
  // Loading
  "Loading games...": "Carregando jogos...",
  
  // Filters
  "Filters": "Filtros",
  "Date": "Data",
  "League": "Liga",
  "Season": "Temporada",
  "Select League": "Selecionar Liga",
  "Select Season": "Selecionar Temporada",
  "Apply Filters": "Aplicar Filtros",
  
  // Pagination
  "Previous": "Anterior",
  "Next": "Próximo",
  
  // Odds Sheet
  "Betting Odds": "Cotações de Apostas",
  "No odds available": "Sem cotações disponíveis",
  "Odds data not available for this game": "Dados de cotações não disponíveis para este jogo",
  
  // Prediction
  "AI Pick": "Escolha da IA",
  "Analyzing...": "Analisando...",
  
  // Teams
  "Away Team": "Time Visitante",
  "Home Team": "Time da Casa",
  "vs": "vs",
  
  // Mobile Prediction Bar
  "Game Selected (Max 5)": "Jogo Selecionado (Máx 5)",
  "Games Selected (Max 5)": "Jogos Selecionados (Máx 5)",
  "7 coins/game": "7 moedas/jogo",
  "coins total": "moedas total",
  "Predict Winners": "Prever Vencedores",
  "Predicting...": "Prevendo...",
  "Insufficient Star Coins. Need": "Moedas Estrela insuficientes. Precisa de",
  "coins.": "moedas.",
  
  // Time
  "ET": "ET",
  "Today": "Hoje",
  "Tomorrow": "Amanhã",
  "Yesterday": "Ontem",
  
  // Date Picker
  "Select Date": "Selecionar Data",
  "January": "Janeiro",
  "February": "Fevereiro",
  "March": "Março",
  "April": "Abril",
  "May": "Maio",
  "June": "Junho",
  "July": "Julho",
  "August": "Agosto",
  "September": "Setembro",
  "October": "Outubro",
  "November": "Novembro",
  "December": "Dezembro",
  "Su": "Dom",
  "Mo": "Seg",
  "Tu": "Ter",
  "We": "Qua",
  "Th": "Qui",
  "Fr": "Sex",
  "Sa": "Sáb",
  "Next Week": "Próxima Semana",
  
  // Close/Back
  "Close": "Fechar",

  // Chat CTA
  "Analyze in Chat": "Analisar no Chat",
  "More in Chat": "Mais no Chat",

  // Upgrade Notice
  "Upgrade to Premium": "Atualizar para Premium",
  "Get unlimited predictions": "Obtenha previsões ilimitadas"
};